"use client";

import { useEffect } from "react";
import { track } from "@/lib/directory-tracking";

// Mide si la gente interactúa con las listas o rebota.
//
// Es el eslabón que faltaba del embudo: sabíamos que llegan (page_view)
// y que algunos contactan (whatsapp_click), pero no si el 90 % que
// muere en el home se va sin clickear nada o clickea y no convierte.
// Son dos problemas distintos con soluciones distintas.
//
// Implementado con delegación de eventos en vez de un onClick por card:
// las cards se renderizan desde server components (SucursalCardTile,
// RegularCard, FeaturedCard) y convertirlas a client solo para trackear
// sería un costo de bundle y de complejidad innecesario. Acá alcanza con
// que el `<a>` lleve unos `data-*`, que son HTML plano.

export default function CardClickTracking(): null {
  useEffect(() => {
    const onClick = (ev: MouseEvent) => {
      const target = ev.target as HTMLElement | null;
      const card = target?.closest?.("[data-track-card]") as HTMLElement | null;
      if (!card) return;

      const comercioId = Number(card.dataset.comercioId);
      const surface = card.dataset.surface ?? null;
      const position = card.dataset.position ? Number(card.dataset.position) : null;
      const section = card.dataset.section ?? null;

      track("card_click", {
        comercioId: Number.isFinite(comercioId) && comercioId > 0 ? comercioId : null,
        // dedupKey por card evita contar doble el click y el auxclick
        // (rueda / botón medio) sobre el mismo elemento.
        dedupKey: `${surface ?? "?"}:${comercioId}`,
        metadata: {
          surface,
          section,
          position,
          path: typeof location !== "undefined" ? location.pathname : null,
        },
      });
    };

    // `capture` para registrar el click aunque el handler del Link
    // navegue y desmonte el árbol.
    document.addEventListener("click", onClick, { capture: true });
    return () => document.removeEventListener("click", onClick, { capture: true });
  }, []);

  return null;
}
